import { sliceCreatePool } from './CreatePool/slice'
import { queryEmployees } from './Employees/query'
import { queryFileUrl } from './FileUrl/query'
import { queryProfile } from './Profile/query'
import { sliceSwap } from './Protocol/slice'
import { sliceWalletConnectClient } from './WalletConnectClient/slice'

export const reducersFund = {
  createPool: sliceCreatePool.reducer,
  [queryEmployees.reducerPath]: queryEmployees.reducer,
  [queryFileUrl.reducerPath]: queryFileUrl.reducer,
  [queryProfile.reducerPath]: queryProfile.reducer,
  signClient: sliceWalletConnectClient.reducer,
  swap: sliceSwap.reducer,
}
export type ReducersFund = typeof reducersFund

export const middlewareFund = [queryEmployees.middleware, queryFileUrl.middleware, queryProfile.middleware]

export type MiddlewareFund = typeof middlewareFund
